/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
'use strict';

angular.module('bulbApp.jplayerModule')

/**
* Our directive that handles the audio (only for mobile only) options for our app.
* Our wrapper for jplayer 2.9.2.
*/
.directive('bulbJplayer', ['$timeout','BulbBitRateService','BITRATE','JPLAYER', bulbJplayer]);

function bulbJplayer($timeout, BulbBitRateService, BITRATE, JPLAYER) {
  return {
    restrict: 'E',
    require: '?^contentBlock',
    scope: {
      targetEntry: '='
    },
    link: function (scope, element, attrs, contentBlockCtrl) {
      if (!angular.isString(attrs.targetEntry)) {
        throw 'bulb-jplayer requires an targetEntry attribute';
      }

      /**
       * Function that pauses all other player instances
       * @param playerId The current player id instance.
       */
      function pauseOtherPlayers(playerId) {
        // Bind an event handler to the instance's play event.
        $(playerId).bind($.jPlayer.event.play, function() {
          // pause all players except this one
          $(this).jPlayer('pauseOthers');
        });
      }

      /**
       * Function that returns the most appropriate audio encoding based off the calculated optimal bitrate.
       *
       * @param index The current index within the audioArray. This will start off as 3 because of how the encodings
       *       are pushed onto the array.
       * @param audioArray The array of audio encodings
       * @param calculatedBitRate The optimal calculated bitrate.
       *
       * @return {String} The url for the audio encoding file.
       */
      function returnAppropriateEncoding(index, audioArray, calculatedBitRate) {
        var audioFile = audioArray[index];

        // The use case if the transcoding process returns a single asset:
        if ( index === 0 ){
          return audioFile.url;
        }
        if (audioFile.bitrate >= calculatedBitRate) {
          return audioFile.url;
        } else {
          return returnAppropriateEncoding((index - 1), audioArray, calculatedBitRate);
        }
      }

      // The object that will hold all of the content-blocks' audio transcoded assets and content-block id.
      var audioArray = {};
      // Function that initializes the audio player with the transcoded audio assets
      var initAudioPlayer = function (playerId, audio) {
        audioArray = {
          playerId : playerId,
          transcodedAssets: []
        };
        audio.transcodedAssets.forEach(function audioAsset(audioAsset) {
          audioArray.transcodedAssets.push({
            url: audioAsset.url,
            bitrate: audioAsset.bitrate
          });
        });

      };

      initAudioPlayer(scope.targetEntry.id, scope.targetEntry.audio);

      /**
       * Callback function that initializes the jplayer with the optimal bitrate transcoded audio asset.
       * @param bitrate The calculated bitrate return from the bitrate-service.
       */
      function initializeJplayer(bitrate) {
        var finalBitrate = (bitrate >= BITRATE.defaultOptions.highestBoundBitrate)
          ? BITRATE.defaultOptions.highestBoundBitrate / 10000 // jshint ignore:line
          : bitrate / 10000;
        var index = audioArray.transcodedAssets.length - 1;
        var playerId;

        var playerVolumeBar,
          cssSelector = {};

        // Setting up the jPlayer instance
        if ( contentBlockCtrl ) { // on editing pages
          playerId = '#jquery_jplayer_' + audioArray.playerId;
          playerVolumeBar = {
            volume: $( '.jp-volume-bar_'  + audioArray.playerId )
          };
          cssSelector = {
            volumeBar: '.jp-volume-bar_' + audioArray.playerId,
            volumeBarValue: '.jp-volume-bar-value_' + audioArray.playerId,
            volumeMax: '.jp-volume-max'
          };

          $timeout( function () {
            $(playerId).jPlayer({
              ready: function (event) {
                // Set the initial volume value on the volume bar:
                playerVolumeBar.volume.find(cssSelector.volumeBarValue)
                  .width( parseInt((event.jPlayer.options.volume) * 100) + '%' );
                $(this).jPlayer('setMedia', {
                  mp3: returnAppropriateEncoding(index, audioArray.transcodedAssets, finalBitrate)
                });
                pauseOtherPlayers(playerId);
              },
              volumechange : function(event) {
                if (event.jPlayer.options.muted) {
                  playerVolumeBar.volume.find(cssSelector.volumeBarValue).width(0);
                } else {
                  playerVolumeBar.volume.find(cssSelector.volumeBarValue)
                    .width(parseInt((event.jPlayer.options.volume) * 100) + '%');
                }
              },
              swfPath: JPLAYER.defaultOptions.swfPath,
              supplied: JPLAYER.defaultOptions.supplied,
              volume: JPLAYER.defaultOptions.volume,
              useStateClassSkin: JPLAYER.defaultOptions.useStateClassSkin,
              cssSelectorAncestor: '#jp_container_' + audioArray.playerId,
              cssSelector : cssSelector,
              autoBlur: JPLAYER.defaultOptions.autoBlur,
              smoothPlayBar: JPLAYER.defaultOptions.smoothPlayBar,
              remainingDuration: JPLAYER.defaultOptions.remainingDuration,
              toggleDuration: JPLAYER.defaultOptions.toggleDuration
            });
          });
        } else { // from within the assetlibrary
          playerVolumeBar = {
            volume: $( '.jp-volume-bar')
          };
          cssSelector = {
            volumeBar: '.jp-volume-bar',
            volumeBarValue: '.jp-volume-bar-value',
            volumeMax: '.jp-volume-max'
          };
          playerId = '#jquery_jplayer_1';
          $(playerId).jPlayer({
            ready: function (event) {
              // Set the initial volume value on the volume bar:
              playerVolumeBar.volume.find(cssSelector.volumeBarValue)
                .width( parseInt((event.jPlayer.options.volume) * 100) + '%' );
              $(this).jPlayer('setMedia', {
                mp3: returnAppropriateEncoding(index, audioArray.transcodedAssets, finalBitrate)
              });
            },
            volumechange : function(event) {
              if (event.jPlayer.options.muted) {
                playerVolumeBar.volume.find(cssSelector.volumeBarValue).width(0);
              } else {
                playerVolumeBar.volume.find(cssSelector.volumeBarValue)
                  .width(parseInt((event.jPlayer.options.volume) * 100) + '%');
              }
            },
            swfPath: JPLAYER.defaultOptions.swfPath,
            supplied: JPLAYER.defaultOptions.supplied,
            volume: JPLAYER.defaultOptions.volume,
            useStateClassSkin: JPLAYER.defaultOptions.useStateClassSkin,
            cssSelectorAncestor: '#jp_container_1',
            cssSelector : cssSelector,
            autoBlur: JPLAYER.defaultOptions.autoBlur,
            smoothPlayBar: JPLAYER.defaultOptions.smoothPlayBar,
            remainingDuration: JPLAYER.defaultOptions.remainingDuration,
            toggleDuration: JPLAYER.defaultOptions.toggleDuration
          });
        }

      }

      BulbBitRateService.getOptimalQuality(initializeJplayer);

    }
  };
}
